/**
 * @generated SignedSource<<cc14b258e3f4349b50e499fda7c17bef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatbotDistributionSettingFields_root$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "ChatbotDistributionSettingFields_root";
};
export type ChatbotDistributionSettingFields_root = ChatbotDistributionSettingFields_root$data;
export type ChatbotDistributionSettingFields_root$key = {
  readonly " $data"?: ChatbotDistributionSettingFields_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatbotDistributionSettingFields_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatbotDistributionSettingFields_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SourceConnection",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SourceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Source",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9eb2a385ca0eff98d19f1eb4aaaa1efc";

export default node;
